(()=>{
  const init=root=>root.querySelectorAll('[data-bundle-options]').forEach(box=>{
    if(box.dataset.ready)return;
    const variants=JSON.parse(box.querySelector('[data-bundle-variants]').textContent);
    const form=box.closest('form'),fallback=box.querySelector('[data-variant-fallback]'),id=fallback.querySelector('select'),fields=box.querySelector('[data-option-fields]'),groups=[...fields.querySelectorAll('[data-option-group]')],submit=form.querySelector('[type=submit]'),price=box.querySelector('[data-option-price]');
    if(!variants.length||!submit)return;
    box.dataset.ready='true';fallback.hidden=true;id.required=false;fields.hidden=false;
    const selectedVariant=variants.find(v=>String(v.id)===box.dataset.selected&&v.available)||(variants.length===1&&variants[0].available?variants[0]:null);
    if(selectedVariant)groups.forEach((group,i)=>{group.querySelectorAll('input').forEach(input=>input.checked=input.value===selectedVariant.options[i]);});
    const update=()=>{
      const selected=[];
      groups.forEach((group,index)=>{
        const radios=[...group.querySelectorAll('[data-option-radio]')];
        radios.forEach(input=>{
          const available=variants.some(v=>v.available&&v.options[index]===input.value&&selected.every((value,i)=>!value||v.options[i]===value));
          input.disabled=!available;input.required=true;
          if(!available)input.checked=false;
          input.closest('label').querySelector('[data-option-sold]').hidden=available;
        });
        selected.push(radios.find(input=>input.checked)?.value||'');
      });
      const complete=selected.every(Boolean),variant=complete?variants.find(v=>v.options.every((o,i)=>o===selected[i])):null;
      id.value=variant?.available?String(variant.id):'';
      submit.disabled=!variant?.available;
      submit.textContent=!variants.some(v=>v.available)?box.dataset.sold:!complete?box.dataset.choose:variant?.available?box.dataset.add:box.dataset.sold;
      if(price)price.textContent=variant?.available?new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:box.dataset.currency||'USD'}).format(variant.price/100):'';
    };
    fields.addEventListener('change',update);
    form.addEventListener('reset',()=>setTimeout(update,0));
    form.addEventListener('submit',event=>{if(!id.value){event.preventDefault();event.stopImmediatePropagation();update();}},true);
    update();
  });
  init(document);document.addEventListener('shopify:section:load',e=>init(e.target));
})();
